import { Box } from '@mui/material';
import {
  TokenSupplyStatusDataAmount,
  TokenSupplyStatusDataGraph,
  TokenSupplyStatusDataName,
} from '../tokenSupplyStatus/PcComponent';

export default function PcTokenSupplyStatus({ type }: { type: string }) {
  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' },
        justifyContent: 'space-between',
        width: '100%',
        gap: '10px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '11.33px',
          minWidth: '230px',
        }}
      >
        <TokenSupplyStatusDataName type={type} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '10px',
          position: 'relative',
          width: '100%',
          maxWidth: '400px',
        }}
      >
        <Box
          sx={{
            width: '3px',
            height: '100%',
            position: 'absolute',
            left: 0,
            top: 0,
            background: '#D9D9D9',
          }}
        ></Box>
        <TokenSupplyStatusDataGraph type={type} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minWidth: '138px',
        }}
      >
        <TokenSupplyStatusDataAmount type={type} />
      </Box>
    </Box>
  );
}
